module.exports = __webpack_public_path__ + "img/solution-dil-system-pic-1.818d68d9.png";